import { HStack } from '@genial/components';
import { BoxRadius, Color, Spacing, Typography } from '@genial/design-tokens';
import { Skeleton } from 'native-base';
import React from 'react';

import {
  TableContent,
  TableContentItemColumn,
} from '../../../../../../../../components/TableContent';

interface SkeletonDesktopProps {}

export const SkeletonDesktop: React.FC<SkeletonDesktopProps> = () => {
  return (
    <TableContent direction="row">
      <HStack flex={1} maxW="410px" space={Spacing['inline.xxs']} alignItems="center">
        <TableContentItemColumn maxW="150px" space={Spacing['inline.quarck']}>
          <Skeleton
            w="35%"
            h={Typography['fontsize.xs']}
            borderRadius={BoxRadius.sm}
            endColor={Color['brand.primary.lightest']}
          />
          <Skeleton
            w="full"
            h={Typography['fontsize.lg']}
            borderRadius={BoxRadius.sm}
            endColor={Color['brand.primary.lightest']}
          />
          <Skeleton
            w="80%"
            h={Typography['fontsize.xs']}
            borderRadius={BoxRadius.sm}
            endColor={Color['brand.primary.lightest']}
          />
        </TableContentItemColumn>
        <TableContentItemColumn maxW="95px" space={Spacing['inline.quarck']}>
          <Skeleton
            w="70%"
            h={Typography['fontsize.xs']}
            borderRadius={BoxRadius.sm}
            endColor={Color['brand.primary.lightest']}
          />
          <Skeleton
            w="full"
            h={Typography['fontsize.lg']}
            borderRadius={BoxRadius.sm}
            endColor={Color['brand.primary.lightest']}
          />
        </TableContentItemColumn>
        <TableContentItemColumn maxW="111px" space={Spacing['inline.quarck']}>
          <Skeleton
            w="40%"
            h={Typography['fontsize.xs']}
            borderRadius={BoxRadius.sm}
            endColor={Color['brand.primary.lightest']}
          />
          <Skeleton
            w="full"
            h={Typography['fontsize.lg']}
            borderRadius={BoxRadius.sm}
            endColor={Color['brand.primary.lightest']}
          />
        </TableContentItemColumn>
      </HStack>
      <HStack flex={1} maxW="200px" space={Spacing['inline.xxxs']} alignItems="center">
        <TableContentItemColumn maxW="150px" space={Spacing['inline.quarck']} alignItems="flex-end">
          <Skeleton
            w="60%"
            h={Typography['fontsize.xs']}
            borderRadius={BoxRadius.sm}
            endColor={Color['brand.primary.lightest']}
          />
          <Skeleton
            w="70%"
            h={Typography['fontsize.lg']}
            borderRadius={BoxRadius.sm}
            endColor={Color['brand.primary.lightest']}
          />
          <Skeleton
            w="full"
            h={Typography['fontsize.xs']}
            borderRadius={BoxRadius.sm}
            endColor={Color['brand.primary.lightest']}
          />
        </TableContentItemColumn>
        <Skeleton
          w="40px"
          h="40px"
          borderRadius={BoxRadius.sm}
          endColor={Color['brand.primary.lightest']}
        />
      </HStack>
    </TableContent>
  );
};
